import { render } from "./CreateVideo.vue?vue&type=template&id=59cbeb70&scoped=true"
import script from "./CreateVideo.vue?vue&type=script&lang=js"
export * from "./CreateVideo.vue?vue&type=script&lang=js"

import "./CreateVideo.vue?vue&type=style&index=0&id=59cbeb70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cbeb70"]])

export default __exports__